export default {
  itemBackground: 'none',
  itemBorderRadius: 0,
  itemPadding: 0,
};
